module.exports = __webpack_public_path__ + "assets/img/vulnerability-copy-link.33f57373.svg";